var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoinline = function SvgLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 447.97,
    height: 50.903,
    viewBox: "0 0 118.525 13.468"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_inline_svg__a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 720h720V0H0Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "logo_inline_svg__b",
    d: "M131.231 226.622H545.54v87.654H131.231z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_inline_svg__a)",
    transform: "matrix(.1201 0 0 -.1201 -27.66 53.09)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h18.752l61.966 95.721-11.414 14.921Z",
    style: {
      fill: "#1a3c5f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(294.465 331.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h14.088l46.551 71.908-8.576 11.209Z",
    style: {
      fill: "#1574a2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(264.297 331.402)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.709l32.078 49.552-5.91 7.725z",
    style: {
      fill: "#4faac7",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(244.854 331.483)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40.441l70.936-110.561H71.385Z",
    style: {
      fill: "#1d02a3",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(363.77 442.044)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30.381l53.288-83.056H53.626Z",
    style: {
      fill: "#008dd2",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(316.36 414.519)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.936l36.722-57.235H36.954Z",
    style: {
      fill: "#74dbfc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(280.731 388.76)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 11.145.291 12.792.264c4.938.106 10.51.227 16.589.286l19.63.248c6.966.086 14.311.199 21.909.228l23.43.13 24.19.052 24.189-.051 23.429-.127c15.197-.089 29.381-.345 41.539-.477 6.078-.059 11.651-.177 16.59-.285l12.791-.267L259.368 0l-11.145-.292-12.791-.267c-4.939-.108-10.512-.226-16.59-.285-12.158-.132-26.342-.388-41.539-.477l-23.429-.127-24.189-.051-24.19.052-23.43.13c-7.598.029-14.943.142-21.909.228l-19.63.248c-6.079.059-11.651.18-16.589.286l-12.792.264z",
    style: {
      fill: "#2e3192",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(230.316 331.402)"
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "GUARDALO.COM",
    style: {
      fontSize: 30,
      lineHeight: 1.25,
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      letterSpacing: "-.837257px",
      whiteSpace: "pre",
      shapeInside: "url(#logo_inline_svg__b)",
      fill: "#1e3264",
      fillOpacity: 1
    },
    transform: "translate(-7.378 -71.056)scale(.31921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.91 243.364h4.44v10.83h-3.66v-1.26q-2.19 1.62-5.64 1.62-2.91 0-5.34-1.26t-3.87-3.66q-1.44-2.43-1.44-5.76 0-3.21 1.47-5.7 1.5-2.52 4.14-3.93t5.94-1.41q2.76 0 5.01.93t3.78 2.7l-3.12 2.88q-2.25-2.37-5.43-2.37-2.01 0-3.57.87-1.56.84-2.43 2.4t-.87 3.6q0 2.13.84 3.63.87 1.5 2.31 2.28 1.44.75 3.15.75 2.55 0 4.29-1.44zM174.793 233.194v21h-4.71v-2.55q-2.16 2.91-6.36 2.91-3.72 0-5.82-2.34-2.07-2.37-2.07-6.72v-12.3h4.86v12.15q0 2.52 1.17 3.81 1.2 1.26 3.24 1.26 2.19 0 3.51-1.35 1.32-1.38 1.32-4.05v-11.82zM188.386 232.834q2.91 0 5.07 1.14t3.36 3.36 1.2 5.37v11.49h-4.86v-5.04h-9.6v5.04h-4.8v-11.49q0-3.15 1.2-5.37t3.36-3.36 5.07-1.14m4.77 12.42v-3q0-2.61-1.29-3.93-1.29-1.35-3.51-1.35-2.25 0-3.54 1.35-1.26 1.32-1.26 3.93v3zM215.359 254.194l-4.05-5.85h-4.470000000000001v5.85h-4.86v-21h9.09q2.79 0 4.83.93 2.07.93 3.18 2.64t1.11 4.05-1.14 4.05q-1.11 1.68-3.18 2.58l4.71 6.75zm-.09-13.38q0-1.77-1.14-2.7-1.14-.96-3.33-.96h-3.96v7.32h3.96q2.19 0 3.33-.96t1.14-2.7M223.191 233.194h9.54q3.42 0 6.03 1.32 2.64 1.29 4.08 3.66 1.47 2.37 1.47 5.52t-1.47 5.52q-1.44 2.37-4.08 3.69-2.61 1.29-6.03 1.29h-9.54zm9.3 17.01q3.15 0 5.01-1.74 1.89-1.77 1.89-4.77t-1.89-4.74q-1.86-1.77-5.01-1.77h-4.44v13.02zM256.584 232.834q2.91 0 5.07 1.14t3.36 3.36 1.2 5.37v11.49h-4.86v-5.04h-9.6v5.04h-4.8v-11.49q0-3.15 1.2-5.37t3.36-3.36 5.07-1.14m4.77 12.42v-3q0-2.61-1.29-3.93-1.29-1.35-3.51-1.35-2.25 0-3.54 1.35-1.26 1.32-1.26 3.93v3zM270.177 233.194h4.86v17.04h10.53v3.96h-15.39zM297.27 254.554q-3.27 0-5.91-1.41-2.61-1.41-4.11-3.87-1.47-2.49-1.47-5.58t1.47-5.55q1.5-2.49 4.11-3.9 2.64-1.41 5.91-1.41t5.88 1.41 4.11 3.9q1.5 2.46 1.5 5.55t-1.5 5.58q-1.5 2.46-4.11 3.87t-5.88 1.41m0-4.14q1.86 0 3.36-.84 1.5-.87 2.34-2.4.87-1.53.87-3.48t-.87-3.48q-.84-1.53-2.34-2.37-1.5-.87-3.36-.87t-3.36.87q-1.5.84-2.37 2.37-.84 1.53-.84 3.48t.84 3.48q.87 1.53 2.37 2.4 1.5.84 3.36.84M312.422 254.434q-1.23 0-2.07-.84t-.84-2.1q0-1.29.84-2.07.84-.81 2.07-.81t2.07.81q.84.78.84 2.07 0 1.26-.84 2.1t-2.07.84M327.455 254.554q-3.21 0-5.82-1.38-2.58-1.41-4.08-3.87-1.47-2.49-1.47-5.61t1.47-5.58q1.5-2.49 4.08-3.87 2.61-1.41 5.85-1.41 2.73 0 4.92.96 2.22.96 3.72 2.76l-3.12 2.88q-2.13-2.46-5.28-2.46-1.95 0-3.48.87-1.53.84-2.4 2.37-.84 1.53-.84 3.48t.84 3.48q.87 1.53 2.4 2.4 1.53.84 3.48.84 3.15 0 5.28-2.49l3.12 2.88q-1.5 1.83-3.72 2.79t-4.95.96M348.278 254.554q-3.27 0-5.91-1.41-2.61-1.41-4.11-3.87-1.47-2.49-1.47-5.58t1.47-5.55q1.5-2.49 4.11-3.9 2.64-1.41 5.91-1.41t5.88 1.41 4.11 3.9q1.5 2.46 1.5 5.55t-1.5 5.58q-1.5 2.46-4.11 3.87t-5.88 1.41m0-4.14q1.86 0 3.36-.84 1.5-.87 2.34-2.4.87-1.53.87-3.48t-.87-3.48q-.84-1.53-2.34-2.37-1.5-.87-3.36-.87t-3.36.87q-1.5.84-2.37 2.37-.84 1.53-.84 3.48t.84 3.48q.87 1.53 2.37 2.4 1.5.84 3.36.84M386.56 232.834q3.72 0 5.79 2.19 2.07 2.16 2.07 6.27v12.9h-4.86v-12.75q0-2.22-1.17-3.33-1.14-1.14-3.03-1.14-2.07 0-3.3 1.2-1.23 1.17-1.23 3.57v12.45h-4.86v-12.75q0-2.22-1.08-3.33-1.08-1.14-2.94-1.14-2.04 0-3.27 1.2-1.23 1.17-1.23 3.57v12.45h-4.86v-21h4.71v2.58q.96-1.41 2.55-2.16 1.59-.78 3.66-.78 2.16 0 3.78.81 1.62.78 2.49 2.28 1.08-1.5 2.82-2.28 1.77-.81 3.96-.81",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontFamily: "&quot",
      InkscapeFontSpecification: "&quot",
      fill: "#1e3264",
      fillOpacity: 1
    }
  })));
};
export default SvgLogoinline;